// src/Settings.ts
export const APP_ENV = process.env.REACT_APP_NODE_ENV ?? process.env.NODE_ENV ?? 'development';
export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').trim();
export const APP_NAME = process.env.REACT_APP_APP_NAME ?? 'AppManager';
